import { createContext, useMemo } from 'react';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { action, observable, reaction } from 'mobx';

export enum TypeNames {
  success = 'success',
  warning = 'warning',
  error = 'error',
  info = 'info',
}

export declare type MessageTypes = keyof typeof TypeNames;

export interface IPromptContent {
  title: string;
  message?: string;
  type: MessageTypes;
  location: string;
}

export const promptContentDefault = {
  title: '',
  type: TypeNames.info,
  location: '',
};

export const RootStoreContext = createContext<RootStore>(null);
RootStoreContext.displayName = 'RootStoreContext';

export class RootStore {
  @observable promptContent: IPromptContent;

  constructor() {
    this.promptContent = promptContentDefault;
    const initialPromptContent =
      typeof sessionStorage !== 'undefined' && sessionStorage.getItem('promptContent');
    if (initialPromptContent) {
      this.promptContent = JSON.parse(initialPromptContent);
    }
  }

  @action
  setPromptContent = (content: IPromptContent) => {
    this.promptContent = content;
  };

  @action
  clearPrompt = () => {
    this.promptContent = promptContentDefault;
  };
}

export function initializeStore() {
  return new RootStore();
}

export const useRootStore = () => {
  const rootStore = useMemo(() => initializeStore(), []);

  reaction(
    () => JSON.stringify(rootStore.promptContent),
    promptContentStr => sessionStorage.setItem('promptContent', promptContentStr),
  );

  return rootStore;
};
